/**
 * Labels is the translated word for each breadcrumb item
 */
export enum BreadcrumbLabels {
  Dashboard = 'Dashboard',

  Shipments = 'Shipments',
  ShipmentsView = 'ViewShipment',
  BulkShipments = 'BulkShipments',

  Users = 'Users',
  UsersView = 'User',
  UsersAdd = 'AddUser',

  Receivers = 'ManageReceivers',
  ReceiversView = 'Receiver',
  ReceiversAdd = 'AddReceiver',

  Customers = 'Customers',
  CustomersMyCustomers = 'MyCustomers',
  CustomersView = 'Customer',
  CustomersAdd = 'AddCustomer',
  CustomersVerify = 'VerifyCustomer',
  CustomersSupport = 'CustomersSupport',
  BusinessUnits = 'BusinessUnits',

  Invoices = 'Invoices',
  InvoicesView = 'Invoice',
  InvoicesAdd = 'AddInvoice',
  CustomersInvoices = 'CustomersInvoices',
  FleetsInvoices = 'FleetsInvoices',
  VendorInvoices = 'VendorInvoices',

  Providers = 'Providers',
  ProvidersView = 'Provider',
  ProvidersAdd = 'AddProvider',
  ProvidersAddBulk = 'AddBulk',
  ProvidersRequest = 'Request',

  Drivers = 'Drivers',
  DriversView = 'Driver',
  DriversAdd = 'AddDriver',

  Trucks = 'Trucks',
  TrucksRented = 'RentedTrucks',
  TrucksView = 'Truck',
  TrucksAdd = 'AddTruck',

  Trailers = 'Trailers',
  TrailersView = 'Trailer',
  TrailersAdd = 'AddTrailer',

  TripPlanning = 'TripPlanning',
  TripPlanningRegularTrucks = 'RegularTrucks',
  TripPlanningRentalTrucks = 'RentalTrucks',

  LiveTracking = 'LiveTracking',
  Orders = 'Orders',
  SalesOrders = 'SalesOrders',
  // Manage
  Settings = 'Settings',
  PreviewOrders = 'PreviewOrders',

  Contracts = 'Contracts',
  ContractsView = 'ContractsView',
  ContractsAdd = 'ContractsAdd',
  ContractsEdit = 'ContractsEdit',
  ContractsTradeLanesAdd = 'ContractsTradeLanesAdd',
  ContractsTradeLanesEdit = 'ContractsTradeLanesEdit',

  Tickets = 'Tickets',

  B2cShipments = 'B2cShipments',
  FleetsB2c = 'FleetsB2c',
  FleetB2c = 'FleetB2c',
  Rules = 'Rules',

  Payments = 'Payments',
  ManageReceivers = 'ManageReceivers',
  Organizations = 'Organizations',
  TripPerformance = 'TripPerformance',
  OnlinebookingLeads = 'OnlinebookingLeads',
}
